<template>
  <div>
    <Card>
      <template slot="header">Settings</template>
      <v-select
        v-model="personGroupID"
        :items="personGroups"
        item-text="personGroupName"
        item-value="personGroupID"
        label="Group"
      />
      <PersonGroup :person-group="personGroupID"/>
    </Card>

  </div>
</template>

<script>
// import vuex mapping
import { mapActions, mapGetters } from 'vuex'
import PersonGroup from '@/components/settings/PersonGroup'

export default {
  components: {
    PersonGroup
  },
  data () {
    return {
      personGroupID: '1'
    }
  },
  computed: {
    ...mapGetters({
      personGroups: 'person/personGroups'
    })
  },
  mounted () {
    this.getPersonGroups()
  },
  methods: {
    ...mapActions({
      getPersonGroups: 'person/getPersonGroups'
    })
  }
}
</script>
